var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#056839",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2302_15513)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3 16C53.1684 16 63.6 26.4316 63.6 39.3C63.6 52.1684 53.1684 62.6 40.3 62.6C27.4316 62.6 17 52.1684 17 39.3C17 26.4316 27.4316 16 40.3 16ZM29.9917 39.9199C30.3043 38.1073 32.3731 37.0981 34.0056 38.0801C34.1537 38.1685 34.2949 38.2733 34.4265 38.3937L34.4391 38.4059C35.1716 39.1078 35.9924 39.8383 36.806 40.5626L37.504 41.1892L45.7867 32.5013C46.2813 31.9833 46.6429 31.6484 47.3851 31.4814C49.9263 30.9207 51.7131 34.0269 49.9122 35.9254L39.5893 46.7589C38.6171 47.7962 36.8793 47.8909 35.8342 46.9002C35.2352 46.3439 34.5837 45.7779 33.925 45.2065C32.7843 44.2153 31.6207 43.2042 30.6722 42.2033C30.1029 41.6344 29.8572 40.7029 29.9917 39.9199Z",
    fill: "#056839",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2302_15513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/Approved.1a8390bb6ec258d1d637a346117a50a0.svg";
export { ForwardRef as ReactComponent };